import { nextTick, reactive, watch } from "vue";

export const LANGUAGE_STORAGE_KEY = "suplasercut_language";
export const DEFAULT_LOCALE = "zh-CN";

export const localeOptions = [
    { label: "English", value: "en-US" },
    { label: "中文", value: "zh-CN" },
];

const messages = {
    "zh-CN": {
        common: {
            back: "返回",
            cancel: "取消",
            confirm: "确定",
            save: "保存",
            submit: "提交",
            selected: "已选",
            notBound: "未绑定",
            bound: "已绑定",
            tip: "提示",
            success: "成功",
            copySuccess: "复制成功",
            empty: "暂无数据",
            selectPlaceholder: "请选择",
            searchPlaceholder: "输入关键词进行搜索",
            totalCount: "共 {total} 条",
            noMore: "没有更多了",
            loading: "正在加载",
        },
        app: {
            bindWechatPrompt: "您还未绑定微信公众号，绑定后可享受更多服务",
            tip: "提示",
            goBind: "去绑定",
        },
        setting: {
            title: "账号设置",
            profileTitle: "个人资料",
            unsetNickname: "未设置昵称",
            unsetCompany: "未填写公司",
            unauthenticated: "未认证",
            avatar: "头像",
            nickname: "昵称",
            company: "公司",
            phone: "手机",
            email: "邮箱",
            wechat: "微信",
            setNow: "去设置",
            fillNow: "去填写",
            pendingVerify: "{email}（待验证）",
            miniProgramOnly: "该功能仅支持在小程序中打开",
            language: {
                title: "语言",
                toast: "已切换为中文",
            },
            about: "关于",
            logout: "退出登录",
            logoutTip: "清除当前登录状态",
        },
        company: {
            title: "公司信息",
            name: "公司名称",
            placeholder: "请输入公司名称",
            desc: "请填写你所在的公司名称",
            required: "请输入公司名称",
            success: "修改成功",
        },
        about: {
            title: "关于",
            brand: "超强伟业",
            product: "Suplaser Cut",
            userAgreement: "用户协议",
            privacyPolicy: "隐私政策",
            technicalSupport: "技术支持",
            supportCompany: "浮烟科技",
            openSourceNotice: "开源许可",
            version: "版本",
            view: "查看",
            unconfigured: "待配置",
            linkUnconfigured: "请先配置正式链接",
            supportUnconfigured: "请先配置技术支持小程序 AppID",
            supportOpening: "正在打开技术支持",
        },
        wechat: {
            title: "微信绑定",
            bindTitle: "关注公众号完成绑定",
            desc: "长按识别二维码，关注并绑定公众号后，可及时接收售后消息通知。",
            boundTitle: "微信公众号已绑定",
            boundDesc: "当前账号已完成微信公众号绑定，可正常接收售后消息通知。",
            boundState: "绑定状态正常",
            boundHint: "后续售后消息通知会继续通过公众号送达，无需重复扫码。",
            loadingCode: "二维码加载中",
            unbind: "解除绑定",
        },
        email: {
            bindTitle: "邮箱绑定",
            verifyTitle: "邮箱验证",
            address: "邮箱地址",
            placeholder: "请输入邮箱地址",
            desc: "绑定常用邮箱后，可用于接收账号通知与售后进度提醒。",
            bind: "绑定",
            resend: "重新发送",
            change: "修改邮箱",
            invalid: "邮箱地址格式不正确",
            used: "邮箱地址已被绑定",
            checkFailed: "邮箱检查失败，请稍后重试",
            waiting: "等待验证",
            resultDesc:
                "请点击发送至 {email} 的验证链接完成验证。该链接有效期为 24 小时，超过期限后需要重新提交验证请求。",
            backSetting: "返回账号设置",
            success: "邮箱验证成功！",
            codeError: "验证码错误",
            codeExpired: "验证码已过期",
            codeUsed: "验证码已使用",
            invalidAccess: "非法访问",
        },
        message: {
            center: "消息中心",
            title: "我的消息",
            readAll: "全部已读",
            unreadCount: "未读消息",
            summaryTitle: "及时关注售后动态",
            summaryDesc: "提交进度、返修通知和系统提醒会在这里同步。",
            searchPlaceholder: "搜索消息内容",
            read: "已读",
            unread: "未读",
            expand: "展开",
            empty: "暂无消息",
            levelNormal: "普通",
            levelImportant: "重要",
            levelUrgent: "紧急",
            markAllReadConfirm: "确定全部标记为已读吗？",
        },
        user: {
            brandAlt: "超强伟业",
            sloganTop: "超品质",
            sloganBottom: "强服务",
            message: "短消息",
            setting: "设置",
            currentAccount: "当前账号",
            fillCompany: "点击完善公司信息",
            setName: "点击设置姓名",
            aiService: "AI客服",
            humanService: "联系我们",
            quickSubmit: "快速提交",
            mySubmit: "提交查询",
            quickTools: "快捷工具",
            all: "全部",
            moreSoon: "超品质，强服务",
            refreshing: "正在刷新",
            releaseRefresh: "松开刷新",
            pullRefresh: "下拉刷新",
            apply: {
                accessory: { title: "配件需求", desc: "申请配件支持" },
                backup: { title: "备机需求", desc: "申请备用设备" },
                repair: { title: "普通返修", desc: "设备返厂维修" },
                quickrp: { title: "快速返修", desc: "快速返修通道" },
            },
            matrix: {
                accessory: { title: "配件提交", desc: "查询配件申请进度" },
                backup: { title: "备机提交", desc: "查询备机申请进度" },
                return: { title: "待返回列表", desc: "待返回的设备" },
                repair: { title: "返修进度", desc: "返修进度跟踪" },
                quickrp: { title: "快速返修", desc: "快速返修记录" },
            },
            tools: {
                decrypt: { title: "设备解密", desc: "设备解密申请" },
                purchase: { title: "采购查询", desc: "订单与采购查询" },
                service: { title: "联系我们", desc: "获取服务支持" },
                evaluate: { title: "意见建议", desc: "反馈体验建议" },
            },
        },
        code: {
            active: {
                deviceNo: "设备编号",
                devicePlaceholder: "请输入设备编号",
                deviceInvalid: "请输入正确的8位数字设备编号",
                days: "使用天数",
                daysPlaceholder: "请输入需要激活的天数",
                daysRequired: "请输入使用天数",
                daysInvalid: "请输入 1-999 之间的数字",
                secret: "密钥",
                copyTip: "点击上方即可复制",
                generate: "生成密钥",
                regenerate: "重新生成",
                generateSuccess: "生成成功",
            },
        },
        guide: {
            title: "服务指南",
        },
        purchase: {
            title: "采购查询",
            detailTitle: "订单详情",
            materialName: "物料名称",
            orderTime: "订单时间",
            deliveryAddress: "收货地址",
            orderInfo: "订单信息",
            orderNo: "订单号",
            outboundNo: "出库单号",
            expressNo: "快递单号",
            materialList: "物料清单",
            emptyMaterial: "暂无物料信息",
            defaultOrderName: "采购订单",
            logistics: "物流信息",
            logisticsDesc: "包裹运输轨迹",
            summarySeparator: "、",
            summaryMore: "等{count}项",
        },
        apply: {
            title: "提交申请",
            subtitle: "选择需要办理的售后类型",
            accessorySubmitDesc: "提交配件采购与补充申请",
            accessoryDesc: "配件采购与补充申请",
            backupSubmitDesc: "提交备用设备调配申请",
            backupDesc: "备用设备调配申请",
            repairTitle: "我要返修",
            repairSubmitDesc: "提交设备返厂维修登记",
            repairDesc: "设备返厂维修登记",
            quickrpSubmitDesc: "提交快速通道维修申请",
            quickrpDesc: "快速通道维修申请",
            quickBadge: "快速",
            submitting: "正在提交",
            failed: "提交失败",
            success: "提交成功",
            backUser: "返回个人中心",
            goMy: "前往我的提交",
            secondsBack: "{seconds}s后返回",
            riskError:
                "您提交的信息触发了系统提示风险，提交失败，检查是否长期未归还物料，无法解决时，请联系超强伟业处理！",
            form: {
                process: "流程",
                integrator: "集成商名称",
                integratorPlaceholder: "请输入集成商名称",
                material: "需求的物料",
                materialPlaceholder: "请选择需求的物料",
                model: "需求的机型",
                modelPlaceholder: "请选择需求的机型",
                repairModel: "返修的机型",
                repairModelPlaceholder: "请选择返修的机型",
                subtype: "子版本",
                subtypePlaceholder: "请选择子版本",
                requiredMaterial: "所需物料",
                requiredMaterialPlaceholder: "请选择所需物料",
                returnMaterial: "寄回的物料",
                sn: "枪头编号",
                snPlaceholder: "输入侧盖SUP开头的编码，区分大小写",
                reason: "需求原因",
                reasonPlaceholder: "输入需求原因",
                repairReason: "返修原因",
                repairReasonPlaceholder: "输入返修原因",
                count: "数量",
                contact: "收货信息",
                contactPlaceholder: "请填写详细的收货信息（联系人、电话、地址）",
                contactRequired: "请输入联系方式",
                remark: "备注",
                remarkPlaceholder: "输入备注",
                repairExpress: "返修物流单号",
                repairExpressPlaceholder: "输入返修物流单号",
                confirmCorrect: "我确认以上信息填写正确",
                confirmCorrectSn:
                    "我确认以上信息填写正确，并承诺如使用虚假的编码SN申报则承担相关费用，系统将拒绝后续的提交",
                confirmReturn: "我会及时按照流程返回",
                confirmRepairStandard: "我已知悉提交返修后将会按照出厂标准维修并接受报价",
                checkCorrect: '请勾选: \\"我确认以上填写信息正确\\"',
                checkReturn: '请勾选: \\"我会及时按照流程返回\\"',
                checkRepairStandard: '请勾选: \\"我已知悉提交返修后将会按照出厂标准维修并接受报价\\"',
                updateSuccess: "更新成功",
            },
        },
        dashboard: {
            index: {
                title: "我的提交",
                subtitle: "查看售后申请、返修进度与待返回事项",
                accessory: {
                    title: "我的配件提交",
                    desc: "配件申请记录与处理状态",
                },
                backup: {
                    title: "我的备机提交",
                    desc: "备机申请记录与调配进度",
                },
                return: {
                    title: "待返回列表",
                    desc: "需要返还或补充物流的事项",
                },
                repair: {
                    title: "我的返修进度",
                    desc: "返修工单进度与维修记录",
                },
                quickrp: {
                    title: "我的快速返修",
                    badge: "快速",
                    desc: "快速通道返修记录",
                },
            },
            listTitle: {
                accessory: "我的配件提交",
                backup: "我的备机提交",
                quickrp: "我的快速返修",
                repair: "我的返修提交",
                return: "待返回列表",
            },
            detail: {
                accessory: "配件提交详情",
                backup: "备机提交详情",
                quickrp: "快速返修详情",
                repair: "返修提交详情",
                submitNo: "提交编号 #{id}",
                orderProgress: "订单进度",
                edit: "修改提交",
                cancel: "取消提交",
                returnBack: "我要返回",
                confirmPaid: "确认我已付款",
                operationSuccess: "操作成功",
                cancelConfirm: "确定要取消提交吗？",
                cancelSuccess: "取消成功",
                model: "型号：",
                count: "数量：",
                submitTime: "提交时间：",
                contact: "联系方式：",
                reason: "原因：",
                remark: "备注：",
                repairReport: "维修报告：",
                sn: "枪头编号：",
                image: "图片：",
                express: "快递：",
                syncedPending: "待同步",
            },
            giveBack: {
                title: "填写单号",
                expressNo: "快递单号",
                expressPlaceholder: "请输入快递单号",
                snPlaceholder: "请输入侧盖SUP开头的编码",
                remarkPlaceholder: "请输入备注",
                abandonConfirm: "是否放弃未提交的内容？",
                submitSuccess: "提交成功",
            },
        },
        misc: {
            loginInMiniProgram: "请重新打开小程序进行登录",
            notFound: "找不到文件",
            noPermission: "没有访问权限",
            pageMissing: "页面不存在",
            pageMissingDesc: "页面未找到",
            backHome: "返回首页",
            backPrevious: "返回上一页",
            logistics: "物流信息",
            repairProcess: "返修流程",
            updateStatus: "更新状态信息",
            express: "快递",
            deviceNo: "设备编号",
            remark: "备注",
            enterExpressNo: "输入快递编号",
            enterDeviceNo: "输入设备编号",
            enterRemark: "输入备注",
            close: "关闭",
            updateSuccess: "更新成功",
            attachment: "附图",
            uploadImage: "请上传图片",
            sendAttachment: "发送附图",
            remove: "移除",
        },
        status: {
            request: {
                0: "待处理",
                1: "已寄出无需返回",
                2: "已寄出待用户返回",
                3: "已返回待确认",
                4: "已确认返回",
                6: "后台挂账",
                7: "后台销账",
                "-1": "已取消",
                "-2": "已拒绝",
            },
            quickrp: {
                0: "待付款",
                1: "已付款",
                2: "已寄出待返回",
                3: "已返回待确认",
                4: "确认返回结束",
                "-1": "已取消",
                "-2": "已拒绝",
            },
            repair: {
                0: "待处理",
                1: "已入库待维修",
                2: "维修中",
                3: "维修完成",
                4: "报价中待发出",
                5: "已发出",
                "-1": "已取消",
                "-2": "其他原因滞留",
            },
        },
    },
    "en-US": {
        common: {
            back: "Back",
            cancel: "Cancel",
            confirm: "Confirm",
            save: "Save",
            submit: "Submit",
            selected: "Selected",
            notBound: "Not bound",
            bound: "Bound",
            tip: "Notice",
            success: "Success",
            copySuccess: "Copied",
            empty: "No data",
            selectPlaceholder: "Select",
            searchPlaceholder: "Search by keyword",
            totalCount: "{total} total",
            noMore: "No more",
            loading: "Loading",
        },
        app: {
            bindWechatPrompt: "Your WeChat official account is not linked. Link it to receive more services.",
            tip: "Notice",
            goBind: "Link now",
        },
        setting: {
            title: "Account Settings",
            profileTitle: "Profile",
            unsetNickname: "No nickname",
            unsetCompany: "No company",
            unauthenticated: "Unverified",
            avatar: "Avatar",
            nickname: "Nickname",
            company: "Company",
            phone: "Phone",
            email: "Email",
            wechat: "WeChat",
            setNow: "Set now",
            fillNow: "Fill in",
            pendingVerify: "{email} (pending verification)",
            miniProgramOnly: "This feature is only available in the mini program.",
            language: {
                title: "Language",
                toast: "Language switched to English",
            },
            about: "About",
            logout: "Log out",
            logoutTip: "Clear current login status",
        },
        company: {
            title: "Company Info",
            name: "Company Name",
            placeholder: "Enter company name",
            desc: "Please enter your company name",
            required: "Enter company name",
            success: "Updated successfully",
        },
        about: {
            title: "About",
            brand: "SUPLASER",
            product: "Suplaser Cut",
            userAgreement: "User Agreement",
            privacyPolicy: "Privacy Policy",
            technicalSupport: "Technical Support",
            supportCompany: "Fuyan Tech",
            openSourceNotice: "Open Source Licenses",
            version: "Version",
            view: "View",
            unconfigured: "Not configured",
            linkUnconfigured: "Configure the official link first.",
            supportUnconfigured: "Configure the support mini program AppID first.",
            supportOpening: "Opening technical support.",
        },
        wechat: {
            title: "WeChat Binding",
            bindTitle: "Follow the official account to finish binding",
            desc: "Long press to scan the QR code. After following and binding the official account, you can receive service notifications in time.",
            boundTitle: "Official account already linked",
            boundDesc:
                "This account is already linked to the official account and can receive service notifications normally.",
            boundState: "Link active",
            boundHint:
                "Future service notifications will continue to arrive through the official account without scanning again.",
            loadingCode: "Loading QR code",
            unbind: "Unlink",
        },
        email: {
            bindTitle: "Email Binding",
            verifyTitle: "Email Verification",
            address: "Email Address",
            placeholder: "Enter email address",
            desc: "Bind your email to receive account notifications and service progress updates.",
            bind: "Bind",
            resend: "Resend",
            change: "Change email",
            invalid: "Invalid email address",
            used: "This email address is already bound",
            checkFailed: "Email check failed. Please try again later.",
            waiting: "Waiting for verification",
            resultDesc:
                "Click the verification link sent to {email}. The link is valid for 24 hours. Submit another verification request after it expires.",
            backSetting: "Back to account settings",
            success: "Email verified successfully.",
            codeError: "Invalid verification code",
            codeExpired: "Verification code expired",
            codeUsed: "Verification code already used",
            invalidAccess: "Invalid access",
        },
        message: {
            center: "Message Center",
            title: "My Messages",
            readAll: "Mark all read",
            unreadCount: "Unread",
            summaryTitle: "Stay updated on service progress",
            summaryDesc: "Submission progress, repair notices, and system alerts are synced here.",
            searchPlaceholder: "Search messages",
            read: "Read",
            unread: "Unread",
            expand: "Expand",
            empty: "No messages",
            levelNormal: "Normal",
            levelImportant: "Important",
            levelUrgent: "Urgent",
            markAllReadConfirm: "Mark all messages as read?",
        },
        user: {
            brandAlt: "SUPLASER",
            sloganTop: "Premium Quality · Exceptional Service",
            sloganBottom: "",
            message: "Messages",
            setting: "Settings",
            currentAccount: "Current Account",
            fillCompany: "Complete company info",
            setName: "Set name",
            aiService: "AI Service",
            humanService: "Contact Us",
            quickSubmit: "Quick Submit",
            mySubmit: "My Submissions",
            quickTools: "Quick Tools",
            all: "All",
            moreSoon: "Premium Quality, Exceptional Service",
            refreshing: "Refreshing",
            releaseRefresh: "Release to refresh",
            pullRefresh: "Pull to refresh",
            apply: {
                accessory: { title: "Parts Request", desc: "Parts support" },
                backup: { title: "Backup Device", desc: "Backup equipment" },
                repair: { title: "Standard Repair", desc: "Device repair" },
                quickrp: { title: "Fast Repair", desc: "Fast repair" },
            },
            matrix: {
                accessory: { title: "Parts Requests", desc: "Parts submitted" },
                backup: { title: "Backup Requests", desc: "Backup submitted" },
                return: { title: "Return List", desc: "Devices to return" },
                repair: { title: "Repair Progress", desc: "Repair tracking" },
                quickrp: { title: "Fast Repair", desc: "Fast repair records" },
            },
            tools: {
                decrypt: { title: "Device Unlock", desc: "Request device unlock" },
                purchase: { title: "Purchase Lookup", desc: "Orders and purchases" },
                service: { title: "Contact Us", desc: "Get support" },
                evaluate: { title: "Feedback", desc: "Share suggestions" },
            },
        },
        code: {
            active: {
                deviceNo: "Device No.",
                devicePlaceholder: "Enter device number",
                deviceInvalid: "Enter a valid 8-digit device number",
                days: "Activation Days",
                daysPlaceholder: "Enter activation days",
                daysRequired: "Enter activation days",
                daysInvalid: "Enter a number from 1 to 999",
                secret: "Key",
                copyTip: "Click the key above to copy",
                generate: "Generate Key",
                regenerate: "Regenerate",
                generateSuccess: "Generated",
            },
        },
        guide: {
            title: "Service Guide",
        },
        purchase: {
            title: "Purchase Lookup",
            detailTitle: "Order Details",
            materialName: "Material",
            orderTime: "Order Time",
            deliveryAddress: "Delivery Address",
            orderInfo: "Order Info",
            orderNo: "Order No.",
            outboundNo: "Outbound No.",
            expressNo: "Tracking No.",
            materialList: "Material List",
            emptyMaterial: "No material info",
            defaultOrderName: "Purchase Order",
            logistics: "Logistics",
            logisticsDesc: "Package tracking",
            summarySeparator: ", ",
            summaryMore: " ({count} items)",
        },
        apply: {
            title: "Submit Request",
            subtitle: "Choose the after-sales service type",
            accessorySubmitDesc: "Submit a parts purchase and replenishment request",
            accessoryDesc: "Parts purchase and replenishment",
            backupSubmitDesc: "Submit a backup device request",
            backupDesc: "Backup equipment allocation",
            repairTitle: "Repair Request",
            repairSubmitDesc: "Submit a device repair request",
            repairDesc: "Register a device repair",
            quickrpSubmitDesc: "Submit a fast repair request",
            quickrpDesc: "Fast repair channel request",
            quickBadge: "Fast",
            submitting: "Submitting",
            failed: "Submit Failed",
            success: "Submitted",
            backUser: "Back to Profile",
            goMy: "View My Submissions",
            secondsBack: "Back in {seconds}s",
            riskError:
                "Your submission triggered a system risk warning. Please check whether materials have been overdue for return. Contact SUPLASER if you cannot resolve it.",
            form: {
                process: "Process",
                integrator: "Integrator",
                integratorPlaceholder: "Enter integrator name",
                material: "Required Material",
                materialPlaceholder: "Select required material",
                model: "Required Model",
                modelPlaceholder: "Select required model",
                repairModel: "Repair Model",
                repairModelPlaceholder: "Select repair model",
                subtype: "Sub-version",
                subtypePlaceholder: "Select sub-version",
                requiredMaterial: "Required Item",
                requiredMaterialPlaceholder: "Select required item",
                returnMaterial: "Returned Item",
                sn: "Serial No.",
                snPlaceholder: "Enter the code starting with SUP on the side cover, case-sensitive",
                reason: "Request Reason",
                reasonPlaceholder: "Enter request reason",
                repairReason: "Repair Reason",
                repairReasonPlaceholder: "Enter repair reason",
                count: "Quantity",
                contact: "Shipping Info",
                contactPlaceholder: "Enter detailed shipping info (contact, phone, address)",
                contactRequired: "Enter contact information",
                remark: "Remark",
                remarkPlaceholder: "Enter remark",
                repairExpress: "Repair Tracking No.",
                repairExpressPlaceholder: "Enter repair tracking number",
                confirmCorrect: "I confirm the information above is correct",
                confirmCorrectSn:
                    "I confirm the information above is correct and accept related costs if a false SN code is used",
                confirmReturn: "I will return items according to the process",
                confirmRepairStandard: "I understand repairs follow factory standards and accept the quote",
                checkCorrect: 'Please check: "I confirm the information above is correct"',
                checkReturn: 'Please check: "I will return items according to the process"',
                checkRepairStandard:
                    'Please check: "I understand repairs follow factory standards and accept the quote"',
                updateSuccess: "Updated",
            },
        },
        dashboard: {
            index: {
                title: "My Submissions",
                subtitle: "View service requests, repair progress, and pending returns",
                accessory: {
                    title: "My Parts Requests",
                    desc: "Parts request records and status",
                },
                backup: {
                    title: "My Backup Requests",
                    desc: "Backup request records and allocation progress",
                },
                return: {
                    title: "Return List",
                    desc: "Items to return or tracking info to provide",
                },
                repair: {
                    title: "My Repair Progress",
                    desc: "Repair order progress and service records",
                },
                quickrp: {
                    title: "My Fast Repairs",
                    badge: "Fast",
                    desc: "Fast repair channel records",
                },
            },
            listTitle: {
                accessory: "My Parts Requests",
                backup: "My Backup Requests",
                quickrp: "My Fast Repairs",
                repair: "My Repair Requests",
                return: "Return List",
            },
            detail: {
                accessory: "Parts Request Details",
                backup: "Backup Request Details",
                quickrp: "Fast Repair Details",
                repair: "Repair Request Details",
                submitNo: "Request #{id}",
                orderProgress: "Order Progress",
                edit: "Edit Submission",
                cancel: "Cancel Submission",
                returnBack: "Return Item",
                confirmPaid: "I have paid",
                operationSuccess: "Done",
                cancelConfirm: "Cancel this submission?",
                cancelSuccess: "Cancelled",
                model: "Model: ",
                count: "Quantity: ",
                submitTime: "Submitted: ",
                contact: "Contact: ",
                reason: "Reason: ",
                remark: "Remark: ",
                repairReport: "Repair Report: ",
                sn: "Serial No.: ",
                image: "Image: ",
                express: "Express: ",
                syncedPending: "Pending sync",
            },
            giveBack: {
                title: "Enter Tracking No.",
                expressNo: "Tracking No.",
                expressPlaceholder: "Enter tracking number",
                snPlaceholder: "Enter the code starting with SUP on the side cover",
                remarkPlaceholder: "Enter remark",
                abandonConfirm: "Discard unsaved content?",
                submitSuccess: "Submitted",
            },
        },
        misc: {
            loginInMiniProgram: "Please reopen the mini program to log in",
            notFound: "File not found",
            noPermission: "No access",
            pageMissing: "Page Not Found",
            pageMissingDesc: "The page was not found",
            backHome: "Back Home",
            backPrevious: "Back",
            logistics: "Logistics",
            repairProcess: "Repair Process",
            updateStatus: "Update Status",
            express: "Express",
            deviceNo: "Device No.",
            remark: "Remark",
            enterExpressNo: "Enter express number",
            enterDeviceNo: "Enter device number",
            enterRemark: "Enter remark",
            close: "Close",
            updateSuccess: "Updated",
            attachment: "Attachment",
            uploadImage: "Upload an image",
            sendAttachment: "Send Attachment",
            remove: "Remove",
        },
        status: {
            request: {
                0: "Pending",
                1: "Shipped, no return needed",
                2: "Shipped, waiting for user return",
                3: "Returned, pending confirmation",
                4: "Return confirmed",
                6: "Backend credit pending",
                7: "Backend credit cleared",
                "-1": "Cancelled",
                "-2": "Rejected",
            },
            quickrp: {
                0: "Pending payment",
                1: "Paid",
                2: "Shipped, waiting for return",
                3: "Returned, pending confirmation",
                4: "Return confirmed and closed",
                "-1": "Cancelled",
                "-2": "Rejected",
            },
            repair: {
                0: "Pending",
                1: "Received, pending repair",
                2: "Repairing",
                3: "Repair complete",
                4: "Quoting, pending shipment",
                5: "Shipped",
                "-1": "Cancelled",
                "-2": "Delayed for other reasons",
            },
        },
    },
};

const literalTranslations = {
    请重新打开小程序进行登录: "Please reopen the mini program to log in",
    页面不存在: "Page Not Found",
    页面未找到: "The page was not found",
    "当前链接可能已失效，返回首页后可以重新进入服务。":
        "The current link may have expired. Return home and enter the service again.",
    没有访问权限: "No access",
    "当前登录状态无法访问该页面，请返回上一页或重新从小程序进入。":
        "The current login state cannot access this page. Go back or reopen it from the mini program.",
    返回首页: "Back Home",
    返回上一页: "Back",
    物流信息: "Logistics",
    返修流程: "Repair Process",
    更新状态信息: "Update Status",
    快递: "Express",
    设备编号: "Device No.",
    备注: "Remark",
    输入快递编号: "Enter express number",
    输入设备编号: "Enter device number",
    输入备注: "Enter remark",
    关闭: "Close",
    附图: "Attachment",
    请上传图片: "Upload an image",
    发送附图: "Send Attachment",
    移除: "Remove",
    提交申请: "Submit Request",
    选择需要办理的售后类型: "Choose the after-sales service type",
    配件需求: "Parts Request",
    提交配件采购与补充申请: "Submit a parts purchase and replenishment request",
    配件采购与补充申请: "Parts purchase and replenishment",
    流程: "Process",
    物料申请: "Material Request",
    返修登记: "Repair Registration",
    维修: "Repair",
    报价付款: "Quote & Payment",
    我司发出: "We Ship",
    用户返回: "User Return",
    确认返回: "Return Confirmed",
    备机需求: "Backup Device",
    备用设备调配申请: "Backup equipment allocation",
    我要返修: "Repair Request",
    设备返厂维修登记: "Return device for repair",
    快速返修: "Fast Repair",
    快速: "Fast",
    快速通道维修申请: "Fast repair channel request",
    正在提交: "Submitting",
    提交失败: "Submit Failed",
    提交成功: "Submitted",
    返回个人中心: "Back to Profile",
    前往我的提交: "View My Submissions",
    配件提交详情: "Parts Request Details",
    备机提交详情: "Backup Request Details",
    快速返修详情: "Fast Repair Details",
    返修提交详情: "Repair Request Details",
    订单进度: "Order Progress",
    修改提交: "Edit Submission",
    取消提交: "Cancel Submission",
    我要返回: "Return Item",
    确认我已付款: "I have paid",
    原因: "Reason",
    "原因：": "Reason: ",
    "备注：": "Remark: ",
    "维修报告：": "Repair Report: ",
    "枪头编号：": "Serial No.: ",
    "图片：": "Image: ",
    "快递：": "Express: ",
    "型号：": "Model: ",
    "数量：": "Quantity: ",
    "提交时间：": "Submitted: ",
    "联系方式：": "Contact: ",
    填写单号: "Enter Tracking No.",
    快递单号: "Tracking No.",
    请输入快递单号: "Enter tracking number",
    请输入侧盖SUP开头的编码: "Enter the code starting with SUP on the side cover",
    是否放弃未提交的内容: "Discard unsaved content",
    "是否放弃未提交的内容？": "Discard unsaved content?",
    集成商名称: "Integrator",
    请输入集成商名称: "Enter integrator name",
    输入集成商名称: "Enter integrator name",
    需求的物料: "Required Material",
    请选择需求的物料: "Select required material",
    需求的机型: "Required Model",
    请选择需求的机型: "Select required model",
    返修的机型: "Repair Model",
    请选择返修的机型: "Select repair model",
    子版本: "Sub-version",
    请选择子版本: "Select sub-version",
    所需物料: "Required Item",
    请选择所需物料: "Select required item",
    寄回的物料: "Returned Item",
    枪头编号: "Serial No.",
    "输入侧盖SUP开头的编码，区分大小写": "Enter the code starting with SUP on the side cover, case-sensitive",
    需求原因: "Request Reason",
    输入需求原因: "Enter request reason",
    返修原因: "Repair Reason",
    输入返修原因: "Enter repair reason",
    返修物流单号: "Repair Tracking No.",
    输入返修物流单号: "Enter repair tracking number",
    数量: "Quantity",
    收货信息: "Shipping Info",
    "请填写详细的收货信息（联系人、电话、地址）": "Enter detailed shipping info (contact, phone, address)",
    我确认以上信息填写正确: "I confirm the information above is correct",
    "我确认以上信息填写正确，并承诺如使用虚假的编码SN申报则承担相关费用，系统将拒绝后续的提交":
        "I confirm the information above is correct and accept related costs if a false SN code is used",
    我会及时按照流程返回: "I will return items according to the process",
    我已知悉提交返修后将会按照出厂标准维修并接受报价:
        "I understand repairs follow factory standards and accept the quote",
    请输入联系方式: "Enter contact information",
    确定要取消提交吗: "Cancel this submission",
    "确定要取消提交吗？": "Cancel this submission?",
    取消成功: "Cancelled",
    操作成功: "Done",
    更新成功: "Updated",
    复制成功: "Copied",
    确定: "Confirm",
    取消: "Cancel",
    提示: "Notice",
    成功: "Success",
    暂无数据: "No data",
    输入关键词进行搜索: "Search by keyword",
    全部: "All",
    "更多服务，敬请期待": "More services coming soon",
    我的资料: "My Profile",
    公司名称: "Company Name",
    姓名: "Name",
    请输入姓名: "Enter name",
    "请尽可能与技术/售后群内备注昵称一致": "Use the same name as your support group nickname when possible",
    "[-1]没有访问权限,请登录后重试": "[-1] No access. Please log in and try again",
};

const textNodeOriginals = new WeakMap();
const attrOriginals = new WeakMap();
let domObserver;
let translatePending = false;

function translateLiteral(value, locale) {
    if (locale !== "en-US") return value;
    return literalTranslations[value] || value;
}

function translateAttributes(element, locale) {
    ["placeholder", "aria-label", "title", "alt"].forEach((attr) => {
        if (!element.hasAttribute?.(attr)) return;
        let originals = attrOriginals.get(element);
        if (!originals) {
            originals = {};
            attrOriginals.set(element, originals);
        }
        if (!originals[attr]) originals[attr] = element.getAttribute(attr);
        const original = originals[attr];
        if (locale !== "en-US" && !literalTranslations[original]) return;
        const next = translateLiteral(original, locale);
        if (element.getAttribute(attr) !== next) element.setAttribute(attr, next);
    });
}

function translateTextNode(node, locale) {
    const raw = node.nodeValue;
    if (!raw || !raw.trim()) return;
    const parent = node.parentElement;
    if (parent?.closest?.("svg,style,script")) return;
    if (!textNodeOriginals.has(node)) textNodeOriginals.set(node, raw);
    const original = textNodeOriginals.get(node);
    const trimmed = original.trim();
    if (locale !== "en-US" && !literalTranslations[trimmed]) return;
    const translated = translateLiteral(trimmed, locale);
    if (translated === trimmed) {
        if (locale !== "en-US" && node.nodeValue !== original) node.nodeValue = original;
        return;
    }
    const prefix = original.match(/^\s*/)?.[0] || "";
    const suffix = original.match(/\s*$/)?.[0] || "";
    node.nodeValue = `${prefix}${translated}${suffix}`;
}

function walkAndTranslate(root, locale) {
    if (typeof document === "undefined" || !root) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT);
    let node = walker.currentNode;
    while (node) {
        if (node.nodeType === Node.TEXT_NODE) {
            translateTextNode(node, locale);
        } else if (node.nodeType === Node.ELEMENT_NODE) {
            translateAttributes(node, locale);
        }
        node = walker.nextNode();
    }
}

function installDomTranslator() {
    if (typeof document === "undefined") return;
    const run = () => walkAndTranslate(document.body, i18nState.locale);
    const schedule = () => {
        if (translatePending) return;
        translatePending = true;
        window.setTimeout(() => {
            translatePending = false;
            nextTick(run);
        }, 80);
    };
    schedule();
    watch(
        () => i18nState.locale,
        () => schedule()
    );
    if (!domObserver) {
        domObserver = new MutationObserver(() => schedule());
        domObserver.observe(document.body, {
            childList: true,
            subtree: true,
        });
    }
}

export const i18nState = reactive({
    locale: readStoredLocale(),
});

function readStoredLocale() {
    if (typeof localStorage === "undefined") return DEFAULT_LOCALE;
    const locale = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    return messages[locale] ? locale : DEFAULT_LOCALE;
}

function applyDocumentLocale(locale) {
    if (typeof document === "undefined") return;
    document.documentElement.lang = locale === "en-US" ? "en" : "zh-CN";
}

function getMessage(locale, key) {
    return key.split(".").reduce((data, segment) => data?.[segment], messages[locale]);
}

export function t(key, params = {}) {
    if (!key) return "";
    const template =
        getMessage(i18nState.locale, key) ?? getMessage(DEFAULT_LOCALE, key) ?? translateLiteral(key, i18nState.locale);
    return String(template).replace(/\{(\w+)\}/g, (_, name) => params[name] ?? "");
}

export function setLocale(locale) {
    if (!messages[locale]) return;
    i18nState.locale = locale;
    if (typeof localStorage !== "undefined") {
        localStorage.setItem(LANGUAGE_STORAGE_KEY, locale);
    }
    applyDocumentLocale(locale);
}

export const i18n = {
    install(app) {
        applyDocumentLocale(i18nState.locale);
        app.config.globalProperties.$locale = i18nState;
        app.config.globalProperties.$t = t;
        app.config.globalProperties.$setLocale = setLocale;
        installDomTranslator();
    },
};
